import { Cart } from '../component/Cart';
import { Footer } from '../component/Footer';

export const CartPage = () => {
  return (
    <section className="cart-page">
      <Cart />
      <Footer />
    </section>
  );
};
